import { render, staticRenderFns } from "./edit-data-parameters.vue?vue&type=template&id=3c0e973f&scoped=true&"
import script from "./edit-data-parameters.vue?vue&type=script&lang=ts&"
export * from "./edit-data-parameters.vue?vue&type=script&lang=ts&"
import style0 from "./edit-data-parameters.vue?vue&type=style&index=0&id=3c0e973f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c0e973f",
  null
  
)

export default component.exports